import React, { Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import dayjs from 'dayjs';
import { EventMoneyTransfer } from '@/model/EventMoneyTransfer';
import EventMoneyTransferStatus from '@/model/EventMoneyTransferStatus';
import { TextArea } from '@/components';

interface ReverseDetailContentProps {
  data?: EventMoneyTransfer;
}

export const DetailContent: React.FC<ReverseDetailContentProps> = ({ data }): JSX.Element => {
  const getTransferStatus = (status: EventMoneyTransferStatus): string => {
    let value = '';
    if (status === EventMoneyTransferStatus.WAITING) {
      value = 'Aguardando';
    } else if (status === EventMoneyTransferStatus.TRANSFERRED) {
      value = 'Transferindo';
    } else if (status === EventMoneyTransferStatus.REFUSED) {
      value = 'Recusado';
    }
    return value;
  };
  return (
    <>
      {data && (
        <div>
          <Row>
            <Col md={12}>
              <label className={'input-label m-0'}>Evento</label>
            </Col>
          </Row>
          <Row>
            <Col md={12}>{data.event.name}</Col>
          </Row>
          <Row style={{ marginTop: '30px' }}>
            <Col md={12}>
              <label className={'input-label m-0'}>Produtor</label>
            </Col>
          </Row>
          <Row>
            <Col md={12}>{data.contractor.name}</Col>
          </Row>
          <Row style={{ marginTop: '30px' }}>
            <Col md={12}>
              <label className={'input-label m-0'}>Banco</label>
            </Col>
          </Row>
          <Row>
            <Col md={12}>{data.pixKey.bank.fullName}</Col>
          </Row>
          <Row style={{ marginTop: '30px' }}>
            <Col md={12}>
              <label className={'input-label m-0'}>Chave</label>
            </Col>
          </Row>
          <Row>
            <Col md={12}>{data.pixKey.key}</Col>
          </Row>
          <Row style={{ marginTop: '30px' }}>
            <Col md={12}>
              <label className={'input-label m-0'}>Solicitante</label>
            </Col>
          </Row>
          <Row>
            <Col md={12}>{data.contractorUser.name}</Col>
          </Row>
          <Row style={{ marginTop: '30px' }}>
            <Col md={12}>
              <label className={'input-label m-0'}>Data solicitação</label>
            </Col>
          </Row>
          <Row>
            <Col md={12}>{dayjs(data.transferRequestDate).format('DD/MM/YYYY HH:mm:ss')}</Col>
          </Row>
          <Row style={{ marginTop: '30px' }}>
            <Col md={12}>
              <label className={'input-label m-0'}>Status</label>
            </Col>
          </Row>
          <Row>
            <Col md={12}>{getTransferStatus(data.transferStatus)}</Col>
          </Row>
          {data.transferDate && (
            <Fragment>
              <Row style={{ marginTop: '30px' }}>
                <Col md={12}>
                  <label className={'input-label m-0'}>Data transferência</label>
                </Col>
              </Row>
              <Row>
                <Col md={12}>{dayjs(data.transferDate).format('DD/MM/YYYY HH:mm:ss')}</Col>
              </Row>
            </Fragment>
          )}
          {data.refusedDate && (
            <Fragment>
              <Row style={{ marginTop: '30px' }}>
                <Col md={12}>
                  <label className={'input-label m-0'}>Data Recusa</label>
                </Col>
              </Row>
              <Row>
                <Col md={12}>{dayjs(data.refusedDate).format('DD/MM/YYYY HH:mm:ss')}</Col>
              </Row>
            </Fragment>
          )}
          {data.refusedReason && (
            <Fragment>
              <Row style={{ marginTop: '30px' }}>
                <Col md={12}>
                  <label className={'input-label m-0'}>Motivo</label>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <TextArea
                    name="refusedReason"
                    label=""
                    value={data.refusedReason}
                    disabled={true}
                    onChange={console.log}
                  />
                </Col>
              </Row>
            </Fragment>
          )}
        </div>
      )}
    </>
  );
};
